export function getSafeAuthCallbackUrl(): string {
  if (typeof window === "undefined") {
    return "/";
  }

  const candidate = new URLSearchParams(window.location.search).get(
    "callbackURL"
  );
  if (!candidate || !candidate.startsWith("/") || candidate.startsWith("//")) {
    return "/";
  }

  try {
    const url = new URL(candidate, window.location.origin);
    if (
      url.origin !== window.location.origin ||
      url.pathname.startsWith("/sign-in")
    ) {
      return "/";
    }
    return `${url.pathname}${url.search}${url.hash}`;
  } catch {
    return "/";
  }
}
